export const CREATE_REPORT = 'VARUNA.CREATE_REPORT'
export const DELETE_REPORT = 'VARUNA.DELETE_REPORT'
export const GET_REPORT = 'VARUNA.GET_REPORT'
export const GET_REPORTS_LIST = 'VARUNA.GET_REPORTS_LIST'
export const UPDATE_REPORT = 'VARUNA.UPDATE_REPORT'
